/* eslint-disable camelcase */
const pt_br = {
    values: {
        acceptable: 'aceitável',
        Action: 'Ação',
        'action plan': 'plano de ação',
        'Action Plan': 'Plano de Ação',
        'Action Plan Mandatory': 'Plano de Ação obrigatório',
        'Action Plan Not Mandatory': 'Plano de Ação não obrigatório',
        'Action Plans': 'Planos de Ação',
        add: 'criar',
        Add: 'Criar',
        'add new': 'adicionar',
        'add participant': 'adicionar participante',
        'add row': 'adicionar linha',
        'add weighing': 'adicionar pesagem',
        ago: 'atrás',
        'All of the analysis steps for rating are desabled': 'Todas as etapas de avaliação estão desativadas',
        'Analysis Steps': 'Etapas de Análise',
        appearance: 'aparência',
        Appearance: 'Aparência',
        Apply: 'Aplicar',
        'Are you sure you want to delete': 'tem certeza que deseja deletar',
        'Asset Tree': 'Árvore de assets',
        Author: 'Autor',
        average: 'média',
        Back: 'voltar',
        bad: 'ruim',
        batch: 'lote',
        Batch: 'Lote',
        Brazil: 'Brasil',
        'Choose an sku': 'Escolha um sku',
        'Choose or drag a file': 'Escolha ou arraste um arquivo',
        'choose the products that belong to this line': 'escolha os produtos que pertencem a essa linha',
        Close: 'Fechar',
        color: 'cor',
        countries: 'países',
        country: 'país',
        'Create Action Plan': 'Criar Plano de Ação',
        critical: 'crítico',
        'current month': 'mês atual',
        Date: 'Data',
        definition: 'definição',
        delay: 'atraso',
        Delay: 'Atraso',
        DELETE: 'DELETAR',
        Deleted: 'Deletado',
        deviations: 'desvios',
        'deviations from': 'desvios de',
        done: 'concluído',
        edit: 'editar',
        'edited by': 'editado por',
        End: 'Fim',
        end: 'fim',
        'Error editing configurations': 'Erro ao editar configurações',
        'Error making request': 'Erro ao fazer requisição',
        'Error retrieving asset tree': 'Erro ao recuperar árvore de assets',
        'Error retrieving data': 'Erro ao recuperar dados',
        excelent: 'excelente',
        factories: 'fábricas',
        Factories: 'Fábricas',
        factory: 'fábrica',
        'final average': 'média final',
        'final result': 'resultado final',
        Finish: 'Finalizar',
        'general information': 'informações gerais',
        'go back to factories': 'retornar a fábricas',
        'Gold Standard': 'Comparação Gold Standard',
        good: 'bom',
        grades: 'notas',
        grammage: 'gramagem',
        'It is not possible to edit general information if the analysis is not from today':
            'Não é possível editar Informações Gerais de uma analise que não foi feita hoje',
        justification: 'justificativa',
        Justification: 'Justificativa',
        'Last Analysis': 'Última Análise',
        'last analysis': 'última análise',
        'last edited': 'editado',
        'Last Result': 'Último Resultado',
        line: 'linha',
        'line name': 'nome da linha',
        'line type': 'tipo de linha',
        lines: 'linhas',
        'loading skus': 'carregando skus',
        'New Analysis': 'Nova Análise',
        next: 'próximo',
        'No Registered analysis for selected span': 'Nenhuma análise registrada para o período selecionado',
        'No Registered Factories': 'Sem Fábricas Cadastradas',
        'No Registered Products': 'Sem Produtos Cadastrados',
        none: 'nenhum',
        operator: 'operador',
        packager: 'empacotadora',
        packaging: 'embalagem',
        Packaging: 'Embalagem',
        "participant's name": 'nome do participante',
        participants: 'participantes',
        pending: 'pendente',
        'Please add at least one deviation if the score is 1 or above':
            'Por favor, adicione pelo menos um desvio caso a nota seja maior que zero',
        'Please enter a start and end date to view a custom span':
            'Por favor, escolha uma data de início e fim para visualizar um período específico',
        'Please fill end date correctly': 'Por favor, preencha a data de fim corretamente',
        'Please fill required fields': 'Por favor, preencha todos os campos obrigatórios',
        'Please fill start date correctly': 'Por favor, preencha a data de início corretamente',
        'Please give a score to all atributes': 'Por favor, dê uma nota a todos os atributos',
        'Please make sure all fields are filled correctly':
            'Por favor, verifique que todos os campos foram preenchidos corretamente',
        'Please make sure start date is before end date':
            'Por favor, verifique se a data de fim é posterior a de início',
        'Please make sure the Action Plan is filled correctly':
            'Por favor, confirme que o Plano de Ação está preenchido corretamente',
        'Plese choose a span shorter than 3 months': 'Por favor, escolha um período menor do que 3 meses',
        primary: 'primário',
        product: 'produto',
        Products: 'Produtos',
        products: 'produtos',
        'Quality Control': 'Controle de Qualidade',
        'Quality Monitoring': 'Controle de Qualidade',
        rating: 'avaliação',
        reason: 'motivo',
        Reason: 'Motivo',
        'Recent Analysis': 'Análises Recentes',
        'Register Stopped Line': 'Registrar Linha Parada',
        regular: 'regular',
        'Remove Image': 'Remover Imagem',
        Result: 'Resultado',
        result: 'resultado',
        'retain and refuse': 'reter e recusar',
        return: 'voltar',
        Save: 'Salvar',
        secondary: 'secundario',
        'select a country': 'selecione um país',
        'select operator type': 'selecione o tipo de operador',
        'sensorial scale': 'escala sensorial',
        'Sensorial Scale': 'Escala Sensorial',
        'sku name': 'nome do sku',
        span: 'período',
        Start: 'Início',
        start: 'início',
        'Stopped Line': 'Linha Parada',
        'stopped line': 'linha parada',
        'take action': 'tomar ações',
        taste: 'sabor',
        Taste: 'Sabor',
        Technology: 'Tecnologia',
        texture: 'textura',
        Texture: 'Textura',
        Time: 'Hora',
        'To view analysis results, please change the selected span':
            'Para visualizar os resultados das análises, por favor selecione outro período',
        'To view analysis stps, please turn them on in configurations':
            'Para ver as etapas de avaliação, habilite as mesmas dentro das configurações',
        'To view the factories, it is necessary to register at least one.':
            'Para vizualizar as fábricas é necessário realizar o cadastro de alguma',
        'To view the products, it is necessary to register at least one.':
            'Para vizualizar os produtos é necessário realizar o cadastro de algum',
        Type: 'Tipo',
        'type batch number': 'digite o número do lote',
        Update: 'Atualizar',
        "wasn't registered due to missing data": 'não foi registrado(a) por falta de dados obrigatórios',
        weighing: 'pesagem',
        weighings: 'pesagens',
        weight: 'peso',
        'What happened?': 'O que aconteceu?',
        'What should be done?': 'O que fazer?',
        'Who did It?': 'Quem Realizou?',
        'Who is in charge?': 'Responsável?',
        'Write here the achieved result': 'Escreva aqui o resultado obtido',
        'Write here the why the line has stopped': 'Escreva aqui o motivo da linha estar parada',
        'Analysis participants': 'Participantes da análise em questão.',
        'Fields referring to the product of the analysis. All fields are mandatory.':
            'Campos referentes ao produto da análise. Todos os campos são obrigatórios.',
        'The first field refers to the weight of the package, the second field refers to a weighing for analysis and the third field is the wrapper number. All fields are mandatory.':
            'O primeiro campo é referente a gramagem do pacote, o segundo campo é referente a uma pesagem para análise e o terceiro campo é o número da empacotadora. Todos os campos são obrigatórios.',
        'Delay time for analysis. Put the justification for the delay in the justification field.':
            'Tempo de atraso para a análise. Coloque a jusfiticativa do atraso no campo justificativa.',
        Required: 'Obrigatório',
        'This weight is 10% greater than the grammage. Check the inserted data!':
            'Este peso é 10% maior que a gramagem. Verifique os dados inseridos!',
        Observation: 'Observação',
        CLEANING: 'LIMPEZA',
        MAINTENANCE: 'MANUTENÇÃO',
        PREVENTIVE: 'PREVENTIVA',
        'NO DEMAND': 'SEM DEMANDA',
        'PROGRAM CHANGE': 'TROCA DE PROGRAMA',
        OTHERS: 'OUTROS',
        'Overweight alert!': 'Alerta de sobrepeso',
        'One or more weights are overweight. Would you like to continue anyway?':
            'Uma ou mais pesagens estão com sobrepeso. Gostaria de continuar mesmo assim?',
        'Write the deviation': 'Escreva o desvio',
        Deviation: 'Desvio',
        operators: 'operadores',
        'There are no SKUs': 'Não há SKUs',
        'Choose a product to configure SKUs': 'Escolha um produto para configurar as SKUs',
        'FREQUENCY FAILURE': 'FALHA DE FREQUÊNCIA',
        'Factory List': 'Lista de fábricas',
        Continue: 'Continuar'
    }
}
module.exports = pt_br
